export default (obj: any): string => {
  const queryParams: string[] = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key]) {
      const value = obj[key];

      if (["string", "number", "boolean"].includes(typeof value)) {
        queryParams.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        );
      } else if (typeof value === "object" && value !== null) {
        for (const nestedKey in value) {
          if (value.hasOwnProperty(nestedKey)) {
            const nestedValue = value[nestedKey];

            if (Array.isArray(nestedValue)) {
              nestedValue.forEach((item: any) => {
                queryParams.push(
                  `${encodeURIComponent(key)}[${encodeURIComponent(
                    nestedKey
                  )}]=${encodeURIComponent(item)}`
                );
              });
            } else {
              queryParams.push(
                `${encodeURIComponent(key)}[${encodeURIComponent(
                  nestedKey
                )}]=${encodeURIComponent(nestedValue)}`
              );
            }
          }
        }
      }
    }
  }

  return queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
};
